<div class="p-6">
  <h2 mat-dialog-title class="text-2xl font-bold text-gray-900 mb-4">
    Edit Bill Amount
  </h2>

  <mat-dialog-content>
    <div class="mb-4">
      <p class="text-sm text-gray-600 mb-2">
        <strong>Project:</strong> {{ data.projectName }}
      </p>
      <p class="text-sm text-gray-600 mb-4">
        <strong>Current Amount:</strong> 
        <span class="font-semibold text-gray-900">{{ formatCurrency(data.currentAmount) }}</span>
      </p>
    </div>

    <form [formGroup]="editForm" class="space-y-4">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>New Bill Amount (INR)</mat-label>
        <input
          matInput
          type="number"
          formControlName="amount"
          min="0"
          step="0.01"
          placeholder="Enter new amount"
        />
        <mat-icon matPrefix>currency_rupee</mat-icon>
        <mat-error *ngIf="editForm.get('amount')?.hasError('required')">
          Amount is required
        </mat-error>
        <mat-error *ngIf="editForm.get('amount')?.hasError('min')">
          Amount must be greater than or equal to 0
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Remark (Required)</mat-label>
        <textarea
          matInput
          formControlName="remark"
          rows="3"
          placeholder="Enter reason for updating the bill amount (minimum 5 characters)"
          maxlength="500"
        ></textarea>
        <mat-hint>Please provide a reason for this amount change</mat-hint>
        <mat-error *ngIf="editForm.get('remark')?.hasError('required')">
          Remark is required
        </mat-error>
        <mat-error *ngIf="editForm.get('remark')?.hasError('minlength')">
          Remark must be at least 5 characters long
        </mat-error>
      </mat-form-field>

      <div class="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <p class="text-sm text-blue-800">
          <mat-icon class="text-blue-600 align-middle mr-1" style="font-size: 18px; width: 18px; height: 18px;">info</mat-icon>
          <strong>Note:</strong> This action can only be performed by Superadmin. The bill amount change will be tracked with original amount, updated amount, timestamp, and your user ID.
        </p>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="mt-6">
    <button
      mat-stroked-button
      (click)="onCancel()"
      class="!border-gray-300 !text-gray-700"
    >
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSave()"
      [disabled]="!editForm.valid"
    >
      Update Amount
    </button>
  </mat-dialog-actions>
</div>
